import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SessionConfigClass;
function SessionConfig() {
  if (SessionConfigClass === VOID) {
    class $ {
      y7d() {
        return window.sessionStorage.getItem('animationDisabled') === 'true';
      }
      z7d() {
        return window.sessionStorage.getItem('thirdPartyAvatarsDisabled') === 'true';
      }
    }
    initMetadataForObject($, 'SessionConfig');
    SessionConfigClass = $;
  }
  return SessionConfigClass;
}
var SessionConfig_instance;
function SessionConfig_getInstance() {
  return SessionConfig_instance;
}
//region block: init
SessionConfig_instance = new (SessionConfig())();
//endregion
//region block: exports
export {
  SessionConfig_instance as SessionConfig_instance1274k0v172tvt,
};
//endregion

//# sourceMappingURL=SessionConfig.mjs.map
